import { httpRequest } from "@utils/HttpRequest";
import { IPage } from "@src/types/FmsTypes";
import { IMdRoleDetail, IMdRoleFields, IMdRoleSearch, IRoleGroup, IUpdateRoleApp, IUpdateRoleMenu, IUpdateRoleResource, IUpdateRoleUsers } from "./RoleTypes";

class RoleService {

    /**
     * 分页获取角色列表
     * @param params 
     * @returns 
     */
    async page(params: IMdRoleSearch) {
        const rolePageUrl = "/auth/role/findPage";
        return await httpRequest.post<IPage<IMdRoleDetail>>(rolePageUrl, params);
    }

    /**
     * 根据条件获取角色列表
     * @param params 
     * @returns 
     */
    async find(params: IMdRoleFields) {
        const rolePageUrl = "/auth/role/find";
        return await httpRequest.post<IMdRoleDetail[]>(rolePageUrl, params);
    }

    /**
     * 根据编码获取角色列表
     * @param code 
     * @returns 
     */
    async findOne(code: string) {
        const rolePageUrl = `/auth/role/findOne/${code}`;
        return await httpRequest.post<IMdRoleDetail>(rolePageUrl);
    }

    /**
     * 新增角色
     * @param params 
     * @returns 
     */
    async insert(params: IMdRoleFields) {
        const roleInsertUrl = "/auth/role/insert";
        return await httpRequest.post<IMdRoleDetail>(roleInsertUrl, params);
    }

    /**
     * 修改角色
     * @param params 
     * @returns 
     */
    async update(params: IMdRoleFields) {
        const roleInsertUrl = "/auth/role/update";
        return await httpRequest.post<boolean>(roleInsertUrl, params);
    }

    /**
     * 删除角色
     * @param code 
     * @returns 
     */
    async remove(code: string) {
        const roleInsertUrl = `/auth/role/remove/${code}`;
        return await httpRequest.post<boolean>(roleInsertUrl);
    }


    /**
    * 更新角色应用信息
    * @param params 
    * @returns 
    */
    async updateRoleApps(params: IUpdateRoleApp) {
        const roleInsertUrl = "/auth/role/updateRoleApps";
        return await httpRequest.post<boolean>(roleInsertUrl, params);
    }

    /**
    * 更新角色菜单信息
    * @param params 
    * @returns 
    */
    async updateRoleMenus(params: IUpdateRoleMenu) {
        const roleInsertUrl = "/auth/role/updateRoleMenus";
        return await httpRequest.post<boolean>(roleInsertUrl, params);
    }

    /**
    * 更新角色资源信息
    * @param params 
    * @returns 
    */
    async updateRoleResources(params: IUpdateRoleResource) {
        const roleInsertUrl = "/auth/role/updateRoleResources";
        return await httpRequest.post<boolean>(roleInsertUrl, params);
    }

    /**
    * 更新角色门户信息
    * @param params 
    * @returns 
    */
    async updateRolePortals(params: IMdRoleFields) {
        const roleInsertUrl = "/auth/role/updateRolePortals";
        return await httpRequest.post<boolean>(roleInsertUrl, params);
    }

    async disable(params: IMdRoleFields) {
        const roleDisableUrl = "/auth/role/disable";
        return await httpRequest.post<boolean>(roleDisableUrl, params);
    }



    /**
     * 获取角色选择项列表
     * @param params 
     * @returns 
     */
    async roleDs(params: IMdRoleFields) {
        let { retData } = await this.find(params);
        console.log(retData)
        return retData.map(el => {
            let label = ""
            if(el.name){
                label = `${el.name}-${el.branchs}`
            }
            return {
                label: label,
                value: el.code ?? ""
            }
        })
    }



    async one(params: IMdRoleFields) {
        const roleDisableUrl = "/auth/role/one";
        return await httpRequest.post<IMdRoleDetail>(roleDisableUrl, params);
    }

    async sync(params: IMdRoleFields) {
        const rolePageUrl = "/auth/role/sync";
        params.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(rolePageUrl, params);
    }

    async syncPage(params: IMdRoleSearch) {
        const rolePageUrl = "/auth/role/syncPage";
        params.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(rolePageUrl, params);
    }

    async syncOne(params: IMdRoleFields) {
        const rolePageUrl = "/auth/role/syncPage";

        return await httpRequest.post<boolean>(rolePageUrl, params);
    }



     /**
     * 分页获取角色分类列表
     * @param params 
     * @returns 
     */
      async roleGroupPage() {
        const rolePageUrl = "/auth/roleGroup/listPage";
        return await httpRequest.post<IRoleGroup[]>(rolePageUrl);
    }

    /**
     * 新增角色分类
     * @param params 
     * @returns 
     */
    async roleGroupInsert(params: IRoleGroup) {
        const roleInsertUrl = "/auth/roleGroup/insert";
        return await httpRequest.post<IMdRoleDetail>(roleInsertUrl, params);
    }

    /**
     * 修改角色分类
     * @param params 
     * @returns 
     */
    async roleGroupUpdate(params: IRoleGroup) {
        const roleInsertUrl = "/auth/roleGroup/update";
        return await httpRequest.post<boolean>(roleInsertUrl, params);
    }

    /**
     * 删除角色分类
     * @param code 
     * @returns 
     */
    async roleGroupRemove(id: string) {
        const roleInsertUrl = `/auth/roleGroup/delete/${id}`;
        return await httpRequest.get<boolean>(roleInsertUrl);
    }


     /**
     * 更新角色用户信息
     * @param params 
     * @returns 
     */
      async updateRoleUsers(params: IUpdateRoleUsers) {
        const roleInsertUrl = "/auth/role/updateRoleUsers";
        return await httpRequest.post<boolean>(roleInsertUrl, params);
    }





}

export const roleService = new RoleService();
